/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateOrUpdateTimecardRequest} from '@cash-web/protos/squareup/timecards/timecards_service.pb'
import {CreateOrUpdateTimecardResponse} from '@cash-web/protos/squareup/timecards/timecards_service.pb'


export const createOrUpdateTimecard = (request: CreateOrUpdateTimecardRequest, options?: CashRequestOptions) => post<CreateOrUpdateTimecardRequest, CreateOrUpdateTimecardResponse>("/proxy/services/squareup.timecards.PublicTimecardsService/CreateOrUpdateTimecard", request, {...options, rejectOnError: true })